export class LoggedUserModel {
  id: string; 
  name: string; 
  email: string;
  image: string;
}